import { FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import PropTypes from 'prop-types';

export const ClinicalInformation = ({ referralDetails = undefined }) => (
    <FormSectionWithRows
        sectionTitle="Clinical Information"
        width="25%"
        isLoading={!referralDetails}
        rowOneContent={
            <DetailLabelValuePair label="Diagnosis" value={referralDetails?.diagnosis} />
        }
    />
);

ClinicalInformation.propTypes = {
    referralDetails: PropTypes.shape({
        diagnosis: PropTypes.string,
    }),
};
